import React from 'react';

const LabelsContext = React.createContext();

export default LabelsContext;
